'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-svg.production.min.js')
} else {
  module.exports = require('./cjs/react-svg.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/react-svg/index.js
// module id = 96
// module chunks = 0